export const borders = {
  "none": "0 solid currentColor",
  "dashed": "1px dashed currentColor",
  "transparent": "1px solid transparent",
  "1px": "1px solid currentColor",
  "2px": "2px solid currentColor",
  "3px": "3px solid currentColor",
  "4px": "4px solid currentColor",
  "6px": "6px solid currentColor"
};